<div class="{{IsPatientView ? 'fitness-item-mobile' : 'fitness-item'}}">
  <div class="item-name-top">
    <div class="item-name">{{ItemName}}</div>
    <div class="item-desc-container" [innerHTML]="ItemDescription"></div>

  </div>
  <div>

    <div class="fitness-item-container">


      <!--<img id="MealItemImage" class="item-image" src='{{ServingSize.ItemImage}}' (click)="onClickImage()" style="width:185px;height:135px" />-->
      <div class="fitness-item-image-outside">

        <div class="fitness-item-image-inside">
          <div class="fitness-item-image-wrapper">
            <img *ngIf="!Item.isQuickAdd && (Item.imageUrl || (Item.useFemaleVersion && Item.femaleImageUrl) || (Item.exerciseVideoThumbnailUrl && Item.exerciseVideoThumbnailUrl != 'null')) else elseVideo" id="MealItemImage" class="fitness-item-image"
              [src]='(Item.exerciseVideoThumbnailUrl && Item.exerciseVideoThumbnailUrl != "null")? Item.exerciseVideoThumbnailUrl : !Item.useFemaleVersion ? Item.imageUrl  : Item.femaleImageUrl' (click)="onClickImage()" />

            <div (click)="onClickImage()" *ngIf="Item.isQuickAdd" class="quick-add-custom-name">{{Item.customName}}</div>

            <ng-template #elseVideo>
              <video width="100%" height="100%"  (click)="onClickImage()">
                <source [src]="!Item.useFemaleVersion ? getVideoUrl(Item.videoUrl) : getVideoUrl(Item.femaleVideoUrl)" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </ng-template>


          </div>
        </div>

        <div class="rest-node-link-simple" [class.superset-rotate]="IsPatientView" *ngIf="(!IsPatientView && !IsLastItem && this.BlockType == 1)">
          <div>
            <span>{{RestToNext}}</span>
          </div>
        </div>

        
        <div class="rest-node-link-simple" [class.superset-rotate]="IsPatientView" *ngIf="(!IsPatientView && IsLastItem && this.BlockType == 1)">
          <div>
            <span>{{RestEnd}}</span>
          </div>
        </div>


        
        <div class="rest-node-link-simple" [class.superset-rotate]="IsPatientView" *ngIf="(!IsPatientView && IsSuperSetWithNext)">
          <div>
            <span>Superset</span>
          </div>
        </div>


      </div>

      <div class="fitness-item-description">
        <div class="item-name-bottom item-name">
          {{ItemName}}
        </div>
        <div class="item-desc-container item-desc-container-bottom" [innerHTML]="ItemDescription"></div>
      </div>

      <div class="exercise-left-overlay">
        {{OrderLabel}}
      </div>


 

      <div class="rest-node-link" *ngIf="(IsPatientView && !IsLastItem && this.BlockType == 1)">
        <div class="rest-between-exercises">
          <span>{{RestToNext}}</span>
        </div>
      </div>




       

      <div class="rest-node-link" *ngIf="(IsPatientView && IsSuperSetWithNext)">
        <div class="rest-between-exercises">
          <span style="margin-left: -4px;">Superset</span>
        </div>
      </div>


    </div>



  </div>


</div>